import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import moment from "moment";
import { filterParams } from "src/app/components/grid/GridHelpers";

export default function useLibraryGridColumns(): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "thematic.name",
            checkboxSelection: true,
            headerName: formatMessage({ id: "content.grid.col.thematic" }),
            minWidth: 122,
            maxWidth: 122,
        },
        {
            field: "writingType",
            headerName: formatMessage({ id: "content.grid.col.writingType" }),
            valueGetter: ({ data }: any) =>
                formatMessage({ id: `content.grid.col.writingType.${data.content.writingType}` }),
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "wordCount",
            headerName: formatMessage({ id: "content.grid.col.wordCount" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 70,
            maxWidth: 70,
        },
        {
            field: "opti",
            headerName: formatMessage({ id: "content.grid.col.opti" }),
            cellRenderer: ({ data }: any) =>
                data.opti ? (
                    <div className="w-100 h-100 d-flex justify-content-center">
                        <SVG
                            width="16px"
                            fill="var(--kt-text-success)"
                            src={toAbsoluteUrl("/media/icons/duotune/general/tick.svg")}
                        />
                    </div>
                ) : (
                    <div className="w-100 h-100 d-flex justify-content-center">
                        <SVG
                            fill="var(--kt-text-danger)"
                            width="16px"
                            src={toAbsoluteUrl("/media/icons/duotune/general/cross.svg")}
                        />
                    </div>
                ),
            filter: "agSetColumnFilter",
            minWidth: 60,
            maxWidth: 60,
        },
        {
            field: "keyword",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => data?.keywords,
            cellRenderer: ({ data }: any) => (
                <div className="thematic-react-tag-wrapper gap-2 pb-2 pt-2">
                    {data?.keywords?.map((category: string, index: number) => (
                        <div key={index} className="thematic-react-tag">
                            {category}
                        </div>
                    ))}
                </div>
            ),
            width: 200,
        },
        {
            field: "content.title",
            headerName: formatMessage({ id: "content.grid.col.title" }),
            width: 300,
        },
        {
            field: "published_at",
            filter: "agDateColumnFilter",
            comparator: (date1, date2) => {
                const timeStamp1 = new Date(
                    moment(date1, "DD/MM/YYYY").format("YYYY-MM-DD")
                ).getTime();
                const timeStamp2 = new Date(
                    moment(date2, "DD/MM/YYYY").format("YYYY-MM-DD")
                ).getTime();
                return timeStamp1 - timeStamp2;
            },
            headerName: formatMessage({ id: "content.grid.col.createdAt" }),
            valueFormatter: ({ data }: any) => moment(data.publishedAt).format("DD/MM/YYYY"),
            filterParams,
            minWidth: 100,
            maxWidth: 100,
        },
    ];

    return gridColumns;
}
